import React from "react";
import GridContainer from "@jumbo/components/GridContainer";
import PageContainer from "@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "@jumbo/utils/IntlMessages";
import { Divider } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import AdminLogDetailsContainer from "@jumbo/Dashboards/AdminLog/AdminLogDetailsContainer";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.adminLog"} />, link: "/adminLog" },
  {
    label: <IntlMessages id={"pages.adminLogDetails"} />,
    isActive: true,
  },
];

const AdminLogDetails = () => {
  return (
    <PageContainer
      heading={<IntlMessages id="pages.adminLogDetails" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <div style={{ marginBottom: "10px" }}>
            <IntlMessages id="pages.adminLogDetails.description" />
          </div>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <AdminLogDetailsContainer />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default AdminLogDetails;